import ButtonPrimaryDark from '@nexus/lib-react/dist/core/Button/ButtonPrimaryDark';
import ButtonSecondaryDark from '@nexus/lib-react/dist/core/Button/ButtonSecondaryDark';
import { mq } from '../../../../../commons/styles';
import styled from '../../../../../theme/styled';

const OrderActions = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 10px;
  margin-bottom: 16px;
  justify-content: space-between;

  ${mq.desktop} {
    flex-direction: row;
    gap: 10px;
    align-items: flex-start;
    margin-bottom: 0;
  }
`;

const BtnContainer = styled.div`
  flex-grow: 1;
  width: 100%;

  ${mq.desktop} {
    align-items: flex-start;
    margin-bottom: 0;
    width: auto;
  }
`;

const AcceptBtn = styled(ButtonPrimaryDark)`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 3px 7px;

  ${mq.desktop} {
    padding: 3px;
  }
`;

const RejectBtn = styled(ButtonSecondaryDark)`
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  ${mq.desktop} {
    padding: 3px 38px;

    &:not(:disabled):hover {
      padding: 3px 35px;
    }
  }
`;

export default {
  OrderActions,
  BtnContainer,
  AcceptBtn,
  RejectBtn,
};
